import * as React from 'react';
import { observer } from 'mobx-react-lite';
import MeetingResponseMessageType from 'owa-service/lib/contract/MeetingResponseMessageType';
import MeetingMessageActionEntrySource from '../../store/schema/MeetingMessageActionEntrySource';
import SummaryRow from './SummaryRow';
import formatMeetingTimeSpan from 'owa-timeformat/lib/utils/formatMeetingTimeSpan';
import EditEventLink from '../EditEventLink';
import { editLinkText } from './MeetingMessageSummary.locstring.json';
import { logMeetingMessageActionForInvite } from '../../utils/logMeetingMessageAction';
import { MeetingMessageActionType } from '../../utils/MeetingMessageActionType';
import loc from 'owa-localize';

const styles = require('./MeetingMessageSummary.scss');

export interface MeetingResponseSummaryProps {
    item: MeetingResponseMessageType;
    entrySource: MeetingMessageActionEntrySource;
}

const MeetingResponseSummary: React.FunctionComponent<MeetingResponseSummaryProps> = props => {
    const { item, entrySource } = props;

    const hasTimeProposal = item.ProposedStart && item.ProposedEnd;

    const logAction = React.useCallback(
        (interactionType: MeetingMessageActionType, propertyNames?: string[]) => {
            logMeetingMessageActionForInvite(interactionType, item, entrySource, propertyNames);
        },
        [item, entrySource]
    );

    return (
        <SummaryRow item={item}>
            {hasTimeProposal && (
                <div className={styles.responseTimeContainer}>
                    <div>{formatMeetingTimeSpan(item.ProposedStart, item.ProposedEnd)}</div>
                    {item.IsOrganizer && (
                        <EditEventLink
                            item={item}
                            logAction={logAction}
                            editLinkClassName={styles.editLink}
                            editLinkText={loc(editLinkText)}
                        />
                    )}
                </div>
            )}
        </SummaryRow>
    );
};

export default observer(MeetingResponseSummary);
